// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"a18cffae","444":"c03cddd6","649":"67856891","833":"a998b75e"}[chunkId] + ".chunk.js";
};